import { useEffect, useState } from 'react';

import { popupApi, popupModel } from '@_entities/system';
import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { shouldShowPopup, syncActivePopups, closePromotionPopup } from '../../libs';

import { IMGPopup, TextPopup } from '../../ui';

export function usePromotionPopupHandler() {
	const [popupList, setPopupList] = useState<popupModel.TPopup[]>([]);
	const [currentPopupIndex, setCurrentPopupIndex] = useState(0);
	const { pushLayer, popLayer } = useUILayerStore();

	function handleClose() {
		closePromotionPopup(popupList[currentPopupIndex].id);
		popLayer();

		if (currentPopupIndex + 1 >= popupList.length) {
			return;
		}

		setCurrentPopupIndex((prev) => prev + 1);
	}

	useEffect(() => {
		popupApi.getPopupList().then(({ data: responseData }) => {
			syncActivePopups(responseData.map((popup) => popup.id));
			setPopupList(responseData.filter((popup) => shouldShowPopup(popup.id)));
		});
	}, []);

	useEffect(() => {
		if (popupList.length > 0) {
			const nextPopup = popupList[currentPopupIndex];

			if (nextPopup.type === 'image') {
				pushLayer('popup', <IMGPopup popup={nextPopup} handleClose={handleClose} />);
			} else {
				pushLayer('popup', <TextPopup popup={nextPopup} handleClose={handleClose} />);
			}
		}
	}, [popupList, currentPopupIndex]);
}
